import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const aiTagDefinition: ResourceDefinition = {
  title: 'AI Tags',
  nameSingular: 'AI Tag',
  namePlural: 'AI Tags',
  className: 'AITag',
  mainIdentifier: 'name',
  slug: 'taxonomies/ai-tags',
  path: 'ai-tags',
  icon: 'icon-tag',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editPolicyInitiativeTaxonomies',
      action: (aiTag) => ({
        type: ActionType.Link,
        link: {
          path: `${aiTagDefinition.path}/${aiTag.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deletePolicyInitiativeTaxonomies',
      action: (aiTag) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: aiTag,
          definition: aiTagDefinition
        }
      })
    }
  ]
}
